import { createContext } from "react"
import { Theme, Variant } from "types/theme"
import { THEMES, VARIANTS } from "utils/theme"

export interface ThemeContextType {
  theme: Theme
  variant: Variant
  setTheme: (theme: Theme) => void
  setVariant: (variant: Variant) => void
}

const ThemeContext = createContext<ThemeContextType>({
  theme: THEMES.LIGHT,
  variant: VARIANTS.BLUE,
  setTheme: () => {},
  setVariant: () => {},
})

export default ThemeContext
